import { captureFocusReturn, focusTarget } from "@whitehaven/ui/focus";

export { captureFocusReturn, focusTarget };

export const ROUTE_FOCUS_EVENT = "whitehaven:route-change";

type QueryRoot = Pick<Document, "querySelector">;

export function focusMainContent(root: QueryRoot = document) {
  return focusTarget(root.querySelector("[data-main-focus]"));
}

export function focusRouteHeading(root: QueryRoot = document) {
  return focusTarget(root.querySelector("[data-route-focus]"));
}
